import React from 'react'
import CategoryDetail from './CategoryDetail'
import FullDetails from './FullDetails'
import SeedDetail from './SeedDetail'
import CompositionDetail from './CompositionDetail'
import CollapsibleCardHeader from '../../../../../components/atoms/cardHeader/collapsibleCardHeader'

const InfoDetail = ({ productbase, detail }) => {
    return (
        <div className="card">
            <CollapsibleCardHeader name="Product Details" target="collapseOne" id="headingOne3" />
            <div
                id="collapseOne"
                className="collapse show"
                data-parent="#vender_product_preview"
            >
                <div className="card-body overflow-hidden">
                    <div className="overflow-hidden product_type">
                        <CategoryDetail productbase={productbase} detail={detail}/>
                        <div className="separator separator-solid my-5"></div>
                        <FullDetails productbase={productbase} detail={detail}/>
                    </div>
                    {productbase !== "MACHINERY" &&
                        (productbase === "SEEDS" ? (
                            <SeedDetail detail={detail}/>
                        ) :
                            <>
                                <div className="separator separator-solid my-5"></div>
                                <CompositionDetail detail={detail} productbase={productbase}/>
                            </>
                        )}
                    <div className="separator separator-solid my-5"></div>
                </div>
            </div>
        </div>
    )
}

export default InfoDetail